import { useMemo } from 'react';

import useForm from '../utils/useForm';
import LenderService from '../../services/LenderService';

const yesNoOptions = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' },
];

const useParticipationForm = (onSubmit, values, readOnly) => {
  const fields = useMemo(
    () => [
      {
        title: 'Participation',
        fields: [
          {
            title: 'Entity Type',
            name: 'entity_type',
            type: 'select',
            options: [
              { value: 'lender', label: 'Lender' },
              { value: 'servicer', label: 'Servicer' },
            ],
            required: true,
          },
          {
            isHidden: (vals) => vals.entity_type !== 'lender',
            title: 'Lender',
            name: 'lender_id',
            type: 'fetchableSelect',
            fetchOptions: {
              key: ['lenders'],
              queryFn: LenderService.getLenders,
              labelKey: 'name',
            },
          },
          {
            title: 'Label',
            name: 'label',
            type: 'select',
            options: [
              { value: 'AUM', label: 'AUM' },
              { value: 'Servicing', label: 'Servicing' },
              { value: 'Participation', label: 'Participation' },
            ],
            required: true,
          },
          {
            title: 'Rate',
            name: 'rate',
            type: 'percentage',
            required: true,
          },
          {
            title: 'Guaranteed',
            name: 'guaranteed',
            type: readOnly ? 'text' : 'radio',
            format: readOnly
              ? (vals) => {
                  return vals?.guaranteed ? 'Yes' : 'No';
                }
              : null,
            options: yesNoOptions,
            defaultValue: true,
          },
          {
            title: 'Priority',
            name: 'priority',
            type: 'select',
            options: [
              { value: 1, label: 1 },
              { value: 2, label: 2 },
              { value: 3, label: 3 },
              { value: 4, label: 4 },
              { value: 5, label: 5 },
            ],
            required: true,
          },
          {
            title: 'Make Whole',
            name: 'make_whole',
            type: readOnly ? 'text' : 'radio',
            format: readOnly
              ? (vals) => {
                  return vals?.make_whole ? 'Yes' : 'No';
                }
              : null,
            options: yesNoOptions,
            defaultValue: true,
          },
          {
            isHidden: (vals) => vals.make_whole === false,
            title: 'Index Rate',
            name: 'index_rate',
            type: 'percentage',
          },
          {
            title: 'Start date',
            name: 'start_date',
            type: 'date',
          },
        ],
      },
    ],
    [readOnly]
  );

  return useForm({ fields, onSubmit, values });
};

export default useParticipationForm;
